import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { WebsiteTextingSubscriptionService } from '../../core/subscription/website-texting-subscription.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'rosie-website-texting-cancel-modal',
  templateUrl: './website-texting-cancel-modal.component.html',
  styleUrls: ['./website-texting-cancel-modal.component.scss'],
  standalone: false
})
export class WebsiteTextingCancelModalComponent {
  @ViewChild('wtCancelModal') modal: NgxSmartModalComponent;
  @Output() cancelled = new EventEmitter<void>();

  reasonControl = new UntypedFormControl('');
  isCancelling = false;

  constructor(
    private wtSubscription: WebsiteTextingSubscriptionService,
    private messageService: MessageService
  ) {}

  open(): void {
    this.reasonControl.reset('');
    this.isCancelling = false;
    this.modal.open();
  }

  close(): void {
    this.modal.close();
  }

  contactSupport(): void {
    this.close();
    const el: any = document.querySelector('.general-intercom-trigger-help');
    if (el) {
      el.click();
    }
  }

  confirmCancel(): void {
    if (this.isCancelling) return;
    this.isCancelling = true;

    this.wtSubscription.cancel(this.reasonControl.value).subscribe({
      next: () => {
        this.isCancelling = false;
        this.messageService.add({
          severity: 'success',
          detail: 'Website Texting has been set to cancel at the end of your billing period.',
          life: 5000
        });
        this.cancelled.emit();
        this.close();
      },
      error: () => {
        this.isCancelling = false;
        this.messageService.add({
          severity: 'error',
          detail: 'Failed to cancel Website Texting. Please try again.',
          life: 5000
        });
      }
    });
  }
}
